import { render, staticRenderFns } from "./payoutForm.vue?vue&type=template&id=2156dd20"
import script from "./payoutForm.vue?vue&type=script&lang=js"
export * from "./payoutForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports